import { useVirtualizer } from "@tanstack/vue-virtual";
import { ref, computed, isRef, unref, nextTick } from "vue";
const usePTableRowVirtualizer = (options) => {
  if (!options.value) {
    return {
      virtualizer: null,
      virtualRows: ref([{ key: 0, index: 0 }]),
      paddingTop: ref(0),
      paddingBottom: ref(0),
      measureElement: () => ref(void 0)
    };
  }
  const virtualizer = useVirtualizer(options);
  const virtualRows = computed(() => virtualizer.value.getVirtualItems());
  const paddingTop = computed(() => virtualRows.value.length > 0 ? virtualRows.value[0].start : 0);
  const paddingBottom = computed(
    () => virtualRows.value.length > 0 ? (virtualizer == null ? void 0 : virtualizer.value.getTotalSize()) - virtualRows.value[virtualRows.value.length - 1].end : 0
  );
  const measureElement = (cmp) => {
    const el = isRef(cmp) ? unref(cmp) : cmp == null ? void 0 : cmp.$el;
    nextTick(() => {
      if (!el) {
        return;
      }
      virtualizer.value.measureElement(el);
    });
    return void 0;
  };
  return { virtualizer, virtualRows, paddingTop, paddingBottom, measureElement };
};
export {
  usePTableRowVirtualizer
};
